import { splitLongText } from 'helpers/text';
import React from 'react';
import { Link } from 'react-router-dom';

class OrderedUserList extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.isReseller && prevProps.users !== this.props.users) {
      // timeout to move syncWidth to async tasks flow
      setTimeout(() => {
        this.syncWidth();
      }, 0);
    }
  }

  syncWidth = () => {
    const tableThs = document
      .querySelector('.main-table')
      .querySelectorAll('thead th');
    const sideRowTable = document.querySelector('.top-row');
    const sideRowTds =
      sideRowTable && sideRowTable.querySelectorAll('tbody td');
    if (tableThs && sideRowTds) {
      tableThs.forEach((th, i) => {
        const td = sideRowTds[i];
        td.style.minWidth = th.clientWidth + 'px';
      });
    }
  };

  handleChangeFilter = (orderKey, ordered) => {
    const { ordering, changeOrdering, notOrderedKeys = [] } = this.props;

    if (ordered === null) {
      return;
    } // ordering doesn't exists
    if (notOrderedKeys.includes(orderKey)) {
      return true;
    } // odering for this key disabled

    const prevOrderKey = ordering[0] === '-' ? ordering.slice(1) : ordering;

    const filter =
      orderKey === prevOrderKey && ordering[0] === '-'
        ? orderKey
        : `-${orderKey}`;

    changeOrdering(filter);
  };

  renderUserRow = (user) => {
    return (
      <tr key={user.id}>
        <td>{user.id}</td>
        <td>{splitLongText(user.first_name)}</td>
        <td>{splitLongText(user.last_name)}</td>
        <td>{splitLongText(user.email, 40)}</td>
        <td>{user.acl_group_name}</td>
        <td>
          <Link to={`/users/${user.id}/view`}>View</Link>
        </td>
      </tr>
    );
  };

  renderHeader = ({ key, label, ordered }, i) => {
    const { ordering, notOrderedKeys = [] } = this.props;
    const orderKey = ordering[0] === '-' ? ordering.slice(1) : ordering;

    return (
      <th
        key={i}
        onClick={() => this.handleChangeFilter(key, ordered)}
        className={
          key && !notOrderedKeys.includes(key) && ordered !== false
            ? 'order-header'
            : 'disabled-order-header'
        }
      >
        {label}
        {orderKey === key ? (ordering[0] === '-' ? ' ↓' : ' ↑') : null}
      </th>
    );
  };

  renderHeaders = () => {
    const headers = [
      { label: 'ID', key: 'id' },
      { label: 'First Name', key: 'first_name' },
      { label: 'Last Name', key: 'last_name' },
      { label: 'Email', key: 'email' },
      { label: 'Role', key: 'role', ordered: false },
      { label: '', key: '' },
    ];

    return <tr>{headers.map((header, i) => this.renderHeader(header, i))}</tr>;
  };

  render() {
    const { users, isReseller, loggedInUser } = this.props;
    const renderedUsers = isReseller
      ? users.filter((user) => user.id !== loggedInUser.id)
      : users;

    return (
      <div>
        {isReseller && (
          <table className="table top-row">
            <tbody>{this.renderUserRow(loggedInUser)}</tbody>
          </table>
        )}
        <table className="table main-table">
          <thead>{this.renderHeaders()}</thead>
          <tbody>
            {renderedUsers.length > 0 && renderedUsers.map(this.renderUserRow)}
          </tbody>
        </table>
      </div>
    );
  }
}

export default OrderedUserList;

OrderedUserList.defaultProps = { notOrderedKeys: [] };
